import { getCurrentPackageName } from 'quartz/framework/environment/service';
import { isInIframeInHubSpot } from './iframe';

// Local storage key for whether Copilot was previously open when the page loaded (i.e. open after a page reload)
// Values can be one of the following integers: 0 | 1 | 2
// 0 = closed | 1 = open | 2 = open expanded view
export const COPILOT_INITIALIZE_OPEN = 'copilot-initialize-open';

// https://github.com/HubSpotEngineering/breeze-assistant-issues/issues/3754
// Gate result is persisted to localStorage (per-app) after auth. On the next
// page load, getShouldStartWithCopilotOpen reads it to decide whether to
// auto-open the panel.
export const COPILOT_AUTO_OPEN = 'copilot-auto-open';
export function getAutoOpenAppKey() {
  try {
    return getCurrentPackageName();
  } catch (_unused) {
    return '';
  }
}
export function getIsCopilotDisabled(navLoaderOptions) {
  if (navLoaderOptions === false) {
    return true;
  }
  if (navLoaderOptions !== null && navLoaderOptions !== void 0 && navLoaderOptions.disableCopilotWhenEmbedded && isInIframeInHubSpot()) {
    return true;
  }
  return false;
}
export const COPILOT_SIDEBAR_SIDE = 'copilot-sidebar-side';
export const getShouldStartWithCopilotOpen = () => {
  try {
    const isCopilotInitiallyOpen = sessionStorage.getItem(COPILOT_INITIALIZE_OPEN);
    const appKey = getAutoOpenAppKey();
    if (appKey) {
      const autoOpenValue = localStorage.getItem(`${COPILOT_AUTO_OPEN}-${appKey}`);
      if (autoOpenValue === 'true') {
        const isAlreadyOpen = isCopilotInitiallyOpen === '1' || isCopilotInitiallyOpen === '2';
        sessionStorage.setItem(COPILOT_INITIALIZE_OPEN, '1');
        if (!isAlreadyOpen) {
          sessionStorage.setItem('copilot-auto-open-triggered', 'true');
        }
        return true;
      }
    }
    return isCopilotInitiallyOpen === '1' || isCopilotInitiallyOpen === '2';
  } catch (e) {
    return false;
  }
};